import { useState, useEffect } from 'react';

export const useTooltipTrigger = elementRef => {
  const [showTooltip, setShowTooltip] = useState(false);

  const compareSize = () => {
    setShowTooltip(elementRef.current && elementRef.current.scrollWidth > elementRef.current.clientWidth);
  };

  useEffect(() => {
    compareSize();
    window.addEventListener('resize', compareSize);
    return () => window.removeEventListener('resize', compareSize);
  });

  return showTooltip;
};
